import { gql } from "@apollo/client";

export const CREATE_CSO = gql`
  mutation create_org_acc(
    $name: String!
    $representative: String!
    $incorporationDate: String!
    $entityForm: String!
    $prefecture: String!
    $city: String!
    $phoneNumber: String!
    $collaborationNeeds: [ID]
    $sdgs: [ID]
    $stakeholders: [ID]
    $homepage: String
    $countries: [ID]
    $revenueCategory: ID!
    $activityFields: [ID]
  ) {
    createOrgAccount(
      input: {
        name: $name
        representative: $representative
        incorporationDate: $incorporationDate
        entityForm: $entityForm
        prefecture: $prefecture
        city: $city
        phoneNumber: $phoneNumber
        collaborationNeeds: $collaborationNeeds
        sdgs: $sdgs
        stakeholders: $stakeholders
        revenueCategory: $revenueCategory
        homepage: $homepage
        countries: $countries
        activityFields: $activityFields
      }
    ) {
      orgAccount {
        id
        pk
        name
        totalOrdinaryRevenue
        prefecture
        city
        street
        logoUrl
        revenueCategory {
          scale
        }
      }
    }
  }
`;
